<template>
    <section>
        <div ref="card"></div>
        <div v-if="hasCardErrors" class="error">{{ errorMsg }}</div>
        <div class="space-between">
            <div></div>
            <button class="btn-link" @click="saveCard">Add Card</button>
        </div>
    </section>
</template>

<script>
    let stripe = Stripe(process.env.VUE_APP_STRIPE);
    let elements = stripe.elements({
        fonts: [
            {
                family: '"Lato"',
                src: 'local("Lato Regular"), local("Lato-Regular"), url(https://fonts.gstatic.com/s/lato/v13/MDadn8DQ_3oT6kvnUq_2r_esZW2xOQ-xsNqO47m55DA.woff2) format("woff2")',
                weight: 300,
                style: 'normal',
                unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215'
            }
        ]
    });
    let card = undefined;

    export default {
        props: ['user'],
        data() {
            return {
                stripeKey: process.env.VUE_APP_STRIPE,
                hasCardErrors: false,
                errorMsg: ""
            }
        },
        methods: {
            saveCard: function () {
                let self = this;
                self.hasCardErrors = false;
                stripe.createToken(card).then(function (result) {
                    if (result.error) {
                        self.hasCardErrors = true;
                        self.errorMsg = result.error.message;
                        self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
                        return;
                    }
                    self.$emit('saveCard', result.token["id"]);
                });
            }
        },
        mounted() {
            let style = {
                base: {
                    fontSize: '16px',
                    '::placeholder': {
                        fontFamily: '"Lato", sans-serif',
                    },
                },
            };
            card = elements.create('card', {
                style: style
            });
            card.mount(this.$refs.card);
        },
        beforeDestroy () {
            card.destroy(this.$refs.card);
        }
    }
</script>
<style>
  /**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
  .StripeElement {
    box-sizing: border-box;

    padding: 10px 12px;

    box-shadow: 0 1px 3px 0 #e6ebf1;
      font-size: 16px;
    color: #3b4054;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.125rem;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  }

  .StripeElement--focus {
      border-color: #13a3eb;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
</style>
